import { useContracts } from '../api/queries.js';
import { Badge, Card, Loading, Page, Problem, Table } from '../components/ui.jsx';
import { formatDateTime } from '../utils/format.js';

/**
 * What each channel promises its consumers. A contract is published, never edited: a new version
 * is appended and becomes the one enforced, so a consumer written against version 2 keeps seeing
 * exactly what version 2 promised.
 */
export function Contracts() {
  const contracts = useContracts();

  if (contracts.isLoading) return <Loading what="i contratti" />;
  if (contracts.error) return <Problem error={contracts.error} />;

  return (
    <Page eyebrow="CONFIGURA" title="Contracts" description="La forma che ogni canale garantisce ai suoi consumatori.">
      <Card>
        <Table
          head={
            <tr>
              <th>Canale</th>
              <th>Versione</th>
              <th>Validazione</th>
              <th>Pubblicato</th>
              <th>Schema</th>
            </tr>
          }
          empty="Nessun contratto pubblicato. Senza contratto Broker accetta qualsiasi payload."
        >
          {contracts.data!.contracts.map((contract) => (
            <tr key={`${contract.channel}-${contract.version}`} className={contract.deprecated ? 'row-muted' : undefined}>
              <td>
                <strong>{contract.channel}</strong>
              </td>
              <td>
                v{contract.version} {contract.deprecated ? <Badge tone="neutral">deprecato</Badge> : null}
              </td>
              <td>
                <Badge tone={contract.enforced ? 'good' : 'warn'}>{contract.enforced ? 'obbligatoria' : 'informativa'}</Badge>
              </td>
              <td className="muted small">{formatDateTime(contract.publishedAt)}</td>
              <td>
                <details>
                  <summary className="muted small">Vedi schema</summary>
                  <pre className="payload">{JSON.stringify(contract.jsonSchema, null, 2)}</pre>
                </details>
              </td>
            </tr>
          ))}
        </Table>
      </Card>
    </Page>
  );
}
